(ns common.db.effects.promise
  (:require [re-frame.core :as rf]))

(rf/reg-fx :promise/resolve
  (fn [resolve-fn reason]
    (when resolve-fn
      (resolve-fn reason))))

(rf/reg-fx :promise/reject
  (fn [reject-fn reason]
    (when reject-fn
      (reject-fn reason))))
